import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/lib/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/authModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/footer/cmplink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/footer/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/footer/trustpilotwidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/app/src/app/_infrastructure/ui/components/header/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/app/src/app/_infrastructure/ui/components/header/mobile/menu/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileSearch"] */ "/app/src/app/_infrastructure/ui/components/header/mobile/MobileSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileLinks"] */ "/app/src/app/_infrastructure/ui/components/header/ProfileLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/app/_infrastructure/ui/components/list/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsMobile"] */ "/app/src/app/_infrastructure/ui/components/list/breadcrumbsMobile.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/onlineshops/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/prefetchonhoverlink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductOverlayHandling"] */ "/app/src/app/_infrastructure/ui/components/product/productOverlayHandling.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/seoquicklinks/seoquicklinks.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SearchForm"] */ "/app/src/app/_infrastructure/ui/components/subheader/SearchForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToTop"] */ "/app/src/app/_infrastructure/ui/components/totop/toTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewEvents"] */ "/app/src/app/_infrastructure/ui/components/tracking/events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/tracking/index.tsx");
